
import { AnchorHTMLAttributes, FC } from "react";
import type { XmExportIconProps } from "../apiDownloader/XmExportIcon";
import XmExportIcon from "../apiDownloader/XmExportIcon";
import "./TableUtil.less";
import { XmDashboardStarIconProps, XmTableDashboardStarIcon } from "./XmDashboardStarIcon";
import { ResetFilterIconProps, XmResetFilterIcon } from "./XmResetFilterIcon";

interface UseIconsProps {
  useExport: boolean;
  useReset: boolean;
  activeReset: boolean;
  useDashboard?: XmDashboardStarIconProps["selectProps"];
}

type XmTableUtilProps = UseIconsProps & ResetFilterIconProps & XmExportIconProps & { label?: string; } & AnchorHTMLAttributes<HTMLDivElement>;

const UNIT_SEPARATOR = " [";

const XmTableUtil: FC<XmTableUtilProps> = ({ useExport, useReset, useDashboard, setTableKey, exportableTypes, export: exp, size, label, activeReset = false, ...props }) => {

  let formattedLabel = label;

  // if (label) {
  //   const index = label.lastIndexOf(UNIT_SEPARATOR);

  //   if (index !== -1) {
  //     formattedLabel =
  //       label.slice(0, index) +
  //       "\n[" +
  //       label.slice(index + UNIT_SEPARATOR.length);
  //   }
  // }

  if (formattedLabel) {
    return (
      <div className="xm-table-util-labeled" {...props}>
        <div>
          <div aria-description="div just for even alignment"></div>
          <span className="xm-table-label">{formattedLabel}</span>
          <div className="xm-table-controls">
            {useReset &&
              <XmResetFilterIcon
                setTableKey={setTableKey}
                size={size}
                disabled={!activeReset}
              />
            }
            {useExport &&
              <XmExportIcon
                exportableTypes={exportableTypes}
                export={exp}
                size={size}
              />
            }
            {useDashboard && <XmTableDashboardStarIcon size={size} selectProps={useDashboard} />}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="xm-table-util" {...props}>
      <div>
        {useReset &&
          <XmResetFilterIcon
            setTableKey={setTableKey}
            size={size}
            disabled={!activeReset}
          />
        }
        {useExport &&
          <XmExportIcon
            exportableTypes={exportableTypes}
            export={exp}
            size={size}
          />
        }
        {useDashboard && <XmTableDashboardStarIcon size={size} selectProps={useDashboard} />}
      </div>
    </div>
  );
};

export default XmTableUtil;